import ServiceDetailLayout from '../components/ServiceDetailLayout';
import { serviceDetails } from '@/mocks/service-details';

export default function CivilWaterproofingPage() {
  return <ServiceDetailLayout data={serviceDetails['civil-waterproofing']} />;
}